import React from 'react';
import { RefreshCw } from 'lucide-react';

const WebSocketStatusBadge = ({
  connected = false,
  className = '',
  onReconnect,
  isReconnecting = false,
}) => {
  // ponytail: only disconnected badge becomes a reconnect button
  const clickable = !connected && typeof onReconnect === 'function';
  const Tag = clickable ? 'button' : 'div';

  return (
    <Tag
      type={clickable ? 'button' : undefined}
      onClick={clickable ? onReconnect : undefined}
      title={clickable ? 'Click to reconnect' : undefined}
      className={`inline-flex min-w-0 max-w-full shrink items-center gap-1.5 rounded-full border px-2 py-0.5 text-[10px] font-semibold transition-colors sm:px-2.5 sm:text-[11px] ${
        connected
          ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
          : 'border-rose-200 bg-rose-50 text-rose-700'
      } ${clickable ? 'cursor-pointer hover:bg-rose-100' : ''} ${className}`.trim()}
    >
      {clickable ? (
        <RefreshCw className={`h-2.5 w-2.5 shrink-0 ${isReconnecting ? 'animate-spin' : ''}`} aria-hidden="true" />
      ) : (
        <span
          className={`h-2 w-2 shrink-0 rounded-full ${
            connected ? 'bg-emerald-500 shadow-[0_0_0_3px_rgba(16,185,129,0.12)]' : 'bg-rose-500 shadow-[0_0_0_3px_rgba(244,63,94,0.12)]'
          }`}
          aria-hidden="true"
        />
      )}
      <span className="min-w-0 truncate text-[9px] uppercase tracking-[0.14em] opacity-80 sm:text-[10px]">
        {connected ? 'Connected' : 'Disconnected'}
      </span>
    </Tag>
  );
};

export default WebSocketStatusBadge;
